import { useTranslation } from "react-i18next";

export const SignalListRow = ({ signal, isSelected, isDirty, onSelect }) => {
  const { t } = useTranslation();
  const isCustomized = signal.source === "team";
  const isOff = !signal.is_enabled;

  const railColorClass = isSelected
    ? "border-l-blue-600"
    : "border-l-transparent";
  const nameColorClass = isOff
    ? "text-gray-400"
    : isSelected
      ? "text-blue-900"
      : "text-gray-900";

  return (
    <button
      type="button"
      data-testid={`signal-row-${signal.signal_type}`}
      onClick={() => onSelect(signal.signal_type)}
      aria-current={isSelected}
      className={`mb-0.5 flex w-full items-center gap-2 rounded-r-lg border-l-2 py-2.5 pl-2.5 pr-2.5 text-left ${railColorClass} ${
        isSelected ? "bg-blue-50" : "bg-transparent hover:bg-gray-50"
      }`}
    >
      <span
        className={`min-w-0 flex-1 truncate text-sm ${isSelected ? "font-semibold" : "font-medium"} ${nameColorClass}`}
      >
        {signal.display_name}
      </span>
      {isDirty && (
        <span
          aria-label={t("pages.settings.signalsPlaybooks.list.unsavedMarker")}
          title={t("pages.settings.signalsPlaybooks.list.unsavedMarker")}
          className="h-1.5 w-1.5 flex-none rounded-full bg-amber-600"
        />
      )}
      {isCustomized && (
        <span className="flex-none text-xs font-medium text-indigo-600">
          {t("pages.settings.signalsPlaybooks.customizedTag")}
        </span>
      )}
      {isOff && (
        <span className="flex-none rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500">
          {t("pages.settings.signalsPlaybooks.offPill")}
        </span>
      )}
    </button>
  );
};
